import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { DebitorAccount, Member } from '@/models/member';
import type { Basket } from '../models/basket';

export const useStore = defineStore('store', () => {
    const basket = ref<Basket>();
    const currentDebitor = ref<DebitorAccount>();
    const currentUser = ref<Member>();
    const hideCartTip = ref<boolean>(false);
    const hideOrderTip = ref<boolean>(false);
    const hideOrdersTip = ref<boolean>(false);

    const getInitialLanguages = () => {
        const rawAttr = document.body?.getAttribute('data-languages') ||
            document.querySelector('body')?.getAttribute('data-languages');

        if (rawAttr) {
            try {
                const parsed = JSON.parse(rawAttr);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    return parsed;
                }
            } catch (e) {
                console.error("Store: Failed to parse data-languages attribute:", e);
            }
        }
        return ['da-DK', 'en-US', 'pl', 'uk'];
    };

    const languages = ref<string[]>(getInitialLanguages());

    const refreshLanguages = () => {
        languages.value = getInitialLanguages();
    };

    // Initial language based on document attribute if available, otherwise first in list
    const docLang = document.documentElement.lang;
    const lang = ref<string>(languages.value.includes(docLang) ? docLang : languages.value[0]);

    const version = ref<string>(import.meta.env.PACKAGE_VERSION);
    const railOpen = ref<boolean>(true);
    const menuOpen = ref<boolean>(false);

    // Lang setter:
    function setLanguage(newLang: string) {
        if (languages.value.includes(newLang)) {
            lang.value = newLang;
        }
    }

    return { basket, currentDebitor, currentUser, hideCartTip, hideOrderTip, hideOrdersTip, lang, version, railOpen, menuOpen, languages, refreshLanguages, setLanguage };
});
